import React, { useCallback } from 'react';
import { Image } from 'components/Image';
import { IconModels, IconTrendUp } from 'components/Icons';
import { listStyled, optionsListItemStyled, optionsListStyled } from 'components/UniversalSearch/components/List/List.styled';
import { useUniversalSearchStore } from 'components/UniversalSearch/UniversalSearchStore';
type ListProps = {
  options: Option[];
};
export const List: React.FC<ListProps> = ({
  options
}) => {
  return <div className={listStyled}>
      {options.map(list => <>
          <p className="list-title">
            {list.title.icon && list.title.icon}
            {list.title.text}
          </p>
          <div className={optionsListStyled}>
            {list.options.map(model => <ListItem key={model.id} model={model} />)}
          </div>
        </>)}
    </div>;
};
type ListItemProps = {
  model: CF.API.Models.Model;
};
const ListItem: React.FC<ListItemProps> = ({
  model
}) => {
  const {
    setSelectedModel
  } = useUniversalSearchStore();
  const onClick = useCallback(() => {
    setSelectedModel(model);
  }, [model]);
  return <div className={optionsListItemStyled} onClick={onClick} onKeyDown={onClick} role="button" tabIndex={0}>
      <div className="img">
        {model.image?.url ? <Image alt={model.display_name} height={100} layout="responsive" priority src={model.image?.url || ''} width={100} /> : <IconModels size={40} />}
      </div>
      <div className="information">
        <p className="title">
          {model.name}
          <span className="title-label">Model</span>
          {model.featured_order ? <IconTrendUp size={20} /> : undefined}
        </p>
        <p className="subtitle">
          {`${model.user_id}`} <span className="dot">·</span> {`${model.app_id}`}
        </p>
      </div>
    </div>;
};
type Option = {
  title: {
    icon?: React.ReactNode;
    text: string;
  };
  options: CF.API.Models.Model[];
};